import React from "react";
import loader from "../assets/images/page-loader.gif";
import logo from "../assets/images/logo.png";

const PageLoader = () => {
  return (
    <div className="page-loader">
        <div className="text-center">
            <img src={logo} alt="logo" style={{ width: '200px' }}  ></img> <br />
            <img src={loader} alt="Loader" style={{ width: '100px' }} ></img>
          </div>
    </div>
  );
};

export default PageLoader;
